export default __webpack_public_path__ + "static/media/sidebar-1.2ea74e53.jpg";